<template>
  <Loader v-if="!isLoaded"/>
  <div v-else>
    <div class="with-side-panel">
      <div class="content-i">
        <div class="content-box">
          <div class="element-wrapper">

            <BackButton
                :label="$t('general.button.back')"
                :to="{ name: 'unemployedPotentialList' }"
                marginBottom="5"/>

            <h6 class="element-header">Interessenten</h6>

            <form @submit.prevent="submitForm">
              <div class="element-box">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.firstName"
                               :label="'Vorname'"
                               :required="true"
                               :validation="v$.firstName"
                               :messages="v$.firstName.required.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.lastName"
                               :label="'Nachname'"
                               :required="true"
                               :validation="v$.lastName"
                               :messages="v$.lastName.required.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <SelectVue v-model="formData.status"
                               :options="unemployedStatusFiltered"
                               :is-clear="true"
                               :label="'Typ'"
                               placeholder="Art auswählen"
                               :required="true"
                               :disabled="disableStatus"
                               :validation="v$.status"
                               :messages="v$.status.required.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.phone"
                               @update:modelValue="onUpdateEmailOrPhoneNumber"
                               :conditionalRequired="true"
                               :label="'Telefonnummer'"
                               :validation="v$.phone"
                               :messages="'Telefon oder E-Mail erforderlich'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.email"
                               :label="'Email'"
                               @update:modelValue="onUpdateEmailOrPhoneNumber"
                               :conditionalRequired="true"
                               :validation="v$.email"
                               :messages="'Telefon oder E-Mail erforderlich'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <SelectVue v-model="formData.contactPersonId"
                               :options="contactPersonsDropdown"
                               :is-clear="true"
                               :label="'BSG Kontakt'"
                               :required="true"
                               placeholder="BSG-Kontakt auswählen"
                               :validation="v$.contactPersonId"
                               :messages="v$.contactPersonId.required.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <SelectVue v-model="formData.interestedIn"
                               :options="interestedInOptions"
                               :is-clear="true"
                               :label="'Interessiert an'"
                               placeholder="Bereich auswählen"
                               :required="true"
                               @update:modelValue="onChangeInterestedIn"
                               :validation="v$.interestedIn"
                               :messages="v$.interestedIn.required.$message"/>
                  </div>
                  <div class="col-lg-8 col-md-6 col-sm-12">
                    <SelectVue v-model="formData.interestDescription"
                               :options="unemployedInterestDescriptions"
                               :is-clear="true"
                               :label="'Infogespräch'"/>
                  </div>
                  <div class="col-lg-6 col-md-12 col-sm-12" v-if="moveLocationDropdown">
                    <SelectVue v-model="formData.locationId"
                               :required="true"
                               :options="officeDropdown"
                               :is-clear="true"
                               :label="'Standort'"
                               placeholder="Standort auswählen"
                               :validation="v$?.locationId"
                               :messages="v$?.locationId?.required?.$message"/>
                  </div>
                  <div class="col-12"  v-if="moveLocationDropdown">
                    <BaseInput v-model="formData.note"
                               :label="'Notiz'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseCheckbox v-if="showAvgsAvailable"
                                  v-model="formData.avgsAvailable"
                                  labelPosition="right"
                                  classFormGroup="mt-1"
                                  :label="'AVGS liegt vor'"/>
                  </div>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <p>Nachfasserinnerung in *</p>
                    <div class="form-row">
                      <BaseRadio
                          v-model="formData.remindIn"
                          label="48 Stunden"
                          name="48 Stunden"
                          id="48"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>

                      <BaseRadio
                          v-model="formData.remindIn"
                          label="1 Wochen"
                          name="1 Wochen"
                          id="7"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>

                      <BaseRadio
                          v-model="formData.remindIn"
                          label="2 Wochen"
                          name="2 Wohen"
                          id="14"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>

                      <BaseRadio
                          v-model="formData.remindIn"
                          label="4 Wochen"
                          name="4 Wocchen"
                          id="28"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-lg-12">
                    <BaseInput v-model="formData.additionalContactPerson"
                               :label="'Weiterer Ansprechpartner'"
                               placeholder="Zuweiser"/>
                  </div>
                  <div class="col-lg-12">
                    <BaseInput v-model="formData.additionalContactPersonInfo"
                               :label="'Kontaktinformation zusätzlicher Ansprechpartner'"/>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <p>Ursprung der Kundenanfrage *</p>
                    <div class="form-row">
                      <BaseRadio
                          v-model="formData.requestOrigin"
                          label="Kontaktseite BSG"
                          name="Kontaktseite BSG"
                          id="bsg_page"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>

                      <BaseRadio
                          v-model="formData.requestOrigin"
                          label="Telefon"
                          name="Telefon"
                          id="phone"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>

                      <BaseRadio
                          v-model="formData.requestOrigin"
                          label="E-Mail"
                          name="E-mail"
                          id="email"
                          :labelPosition="'right'"
                          classFormGroup="col-auto"/>
                    </div>
                  </div>
                </div>

                <div v-if="formData.interestedIn === 'BeWo'">
                  <div class="row mt-4">
                    <div class="col-12">
                      <p style="font-size: 14px; border-bottom: 1px solid black;">BeWo</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <BaseInput v-model="formData.referrerDoctor" :label="'Zuweiser'"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-8 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.specialistMedialOpinion"
                          label="Fachärztlche Stellungnahme"
                          :labelPosition="'right'"/>
                    </div>
                    <div class="col-lg-8 col-md-12 col-sm-12" v-if="formData.specialistMedialOpinion">
                      <BaseInput v-model="formData.referrer"
                                 placeholder="'Zuweiser'"
                                 :validation="v$?.referrer"
                                 :messages="v$?.referrer?.required?.$message"/>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-md-8 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.legalGuardian"
                          label="Rechtlicher Betreuer"
                          :labelPosition="'right'"/>
                    </div>
                    <div class="col-lg-8 col-md-12 col-sm-12" v-if="formData.legalGuardian">
                      <BaseInput v-model="formData.legalGuardianDescription"
                                 placeholder="'Rechtlicher Betreuer'"
                                 :validation="v$?.legalGuardianDescription"
                                 :messages="v$?.legalGuardianDescription?.required?.$message"/>
                    </div>
                  </div>
                  <!--                  <div class="row">-->
                  <!--                    <div class="col-lg-4">-->
                  <!--                      <BaseCheckbox-->
                  <!--                          v-model="formData.voIsPresent"-->
                  <!--                          label="VO liegt vor"-->
                  <!--                          :labelPosition="'right'"/>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="row mt-4">
                    <div class="col-6">
                      <p style="font-size: 14px;">Termine:</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-md-8 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.informationalConversation"
                          label="Infogespräch"
                          :labelPosition="'right'"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12" v-if="formData.informationalConversation">
                      <Datepicker v-model="formData.informationalConversationDate"
                                  placeholder="Datum"
                                  :validation="v$?.informationalConversationDate"
                                  :messages="v$?.informationalConversationDate?.required?.$message"/>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-md-8 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.consultation"
                          label="Beratungsgespräch"
                          :labelPosition="'right'"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12" v-if="formData.consultation">
                      <Datepicker v-model="formData.consultationDate"
                                  placeholder="Datum"
                                  :validation="v$?.consultationDate"
                                  :messages="v$?.consultationDate?.required?.$message"/>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-md-8 col-sm-12">
                      <BaseCheckbox
                          v-model="formData.needsAssessmentInterview"
                          label="Bedarfserhebungsgespräch"
                          :labelPosition="'right'"/>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12" v-if="formData.needsAssessmentInterview">
                      <Datepicker v-model="formData.needsAssessmentInterviewDate"
                                  placeholder="Datum"
                                  :validation="v$?.needsAssessmentInterviewDate"
                                  :messages="v$?.needsAssessmentInterviewDate?.required?.$message"/>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4">
                      <Datepicker v-model="formData.documentsSentOn"
                                  label="Unterlagen versendet am"
                                  placeholder="Datum"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="element-box">
                <p class="mb-5">Um einen Interessenten in einen Kunden umzuwandeln, müssen alle mit blauen Sternen
                  gekennzeichneten
                  Angaben ausgefüllt sein.</p>
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.children"
                        type="number"
                        :label="'Kinder'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.street"
                               :conditionalRequired="true"
                               :label="'Straße'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: -22px">
                    <BaseInput v-model="formData.mobilePhoneNumber"
                               :label="'Nr. für Terminerinnerung (Handynummer) (Mit Ländercode +49)'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.aaNumber"
                               :label="'JC / AA Nummer'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.zip"
                               :conditionalRequired="true"
                               :label="'PLZ'"
                               type="text"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.fileNumber61p"
                               :label="'Aktenzeichen 61.P'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.fileNumberLandscapeAssociation"
                               :label="'Aktenzeichen Landschaftsverband'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.city"
                               :conditionalRequired="true"
                               :label="'Ort'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.fileNumber61l"
                               :label="'Aktenzeichen 61.L'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.insuranceNumber"
                               :label="'Versicherungsnr'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12" v-if="!moveLocationDropdown">
                    <SelectVue v-model="formData.locationId"
                               :conditionalRequired="!moveLocationDropdown"
                               :options="officeDropdown"
                               :is-clear="true"
                               :label="'Standort'"
                               placeholder="Standort auswählen"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.cardIK"
                               :label="'Karten IK'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.nationality"
                               :label="'Nationalität'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <Datepicker v-model="formData.birthDate"
                                :conditionalRequired="true"
                                label="Geburtsdatum"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <SelectVue v-model="formData.gender"
                               :options="genders"
                               placeholder="Gender auswählen"
                               :is-clear="true"
                               :label="'Gender'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput v-model="formData.maritalStatus" :label="'Familienstand'"/>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <p>AVGS Gültigkeit</p>
                    <div class="row" style="margin-top: 33px;">
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker v-model="formData.avgsStartDate" label="Start"/>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker v-model="formData.avgsEndDate" label="Ende"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <p>Zuzahlungsbefreiung</p>
                    <div class="form-row">
                      <BaseRadio
                          v-model="formData.coPaymentExemption"
                          label="Ja"
                          name="coPaymentExemption"
                          id="1"
                          classFormGroup="col-auto"
                          @change="onCoPaymentExceptionChange"
                          :labelPosition="'right'"/>

                      <BaseRadio
                          v-model="formData.coPaymentExemption"
                          label="Nein"
                          name="coPaymentExemption"
                          id="0"
                          classFormGroup="col-auto"
                          @change="onCoPaymentExceptionChange"
                          :labelPosition="'right'"/>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker v-model="formData.coPaymentExemptionStartDate" :label="false"
                                    :disabled="coPaymentExceptionDateDisable"/>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker v-model="formData.coPaymentExemptionEndDate" :label="false"
                                    :disabled="coPaymentExceptionDateDisable"/>
                      </div>
                    </div>
                  </div>
                </div>

                <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>
                <div class="form-buttons-w text-center d-flex justify-content-center align-items-center flex-wrap" style="gap: 12px;">
                  <SaveButton
                      :label="$t('general.button.save')"
                      :loading="isSubmitting"
                      @click="setAction('save')"/>

                  <SaveButton
                      label="Speichern und In Kunden umwandeln"
                      type="button"
                      :disabled="finalSaveButtonDisabled"
                      @click="finalSave()"/>
                </div>
              </div>
            </form>

          </div>
        </div>

        <ModalConfirm
            v-model="showFinalSaveModal"
            confirmationQuestion="Sind Sie sicher, dass Sie sparen und in Kunden konvertieren??"
            :header="''"
            :onConfirm="() => submitForm(true)"/>

        <Sidebar></Sidebar>
      </div>
    </div>
  </div>
</template>

<script setup>
import unemployedService from '@/api/Unemployed/index';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import CreateButton from '@/components/CreateButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import Loader from '@/components/Loader.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {getContactsForPotentialUnemployed, getOfficeByUserRoleDropdown} from '@/shared/dropdowns';
import {isValidEmail, requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import BackButton from "@/components/button/BackButton.vue";
import SaveButton from "@/components/button/SaveButton.vue";

const {t} = useI18n();

const piniaEnumsState = piniaEnumsStore();
const unemployedStatusFiltered = computed(() => {
  return piniaEnumsState.enums.unemployedStatus.filter(status =>
      status.value === 'waiting_list' || status.value === 'potential',
  );
});

const {unemployedInterestDescriptions, genders} = computed(() => piniaEnumsState.enums).value;

const isLoaded = ref(false);
const isSubmitting = ref(false);
const showFinalSaveModal = ref(false);
const contactPersonsDropdown = ref([]);
const officeDropdown = ref([]);
const coPaymentExceptionDateDisable = ref(true);
const route = useRoute();
const unemployedId = route.params.id;
const showAvgsAvailable = ref(true);
const moveLocationDropdown = ref(false);
const disableStatus = ref(false);

const formData = ref({
  buttonType: 'save',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  status: '',
  contactPersonId: null,
  interestedIn: '',
  interestDescription: '',
  avgsAvailable: false,
  remindIn: '48',
  requestOrigin: 'bsg_page',
  additionalContactPerson: '',
  additionalContactPersonInfo: '',

  // Additional fields
  referrerDoctor: '',
  specialistMedialOpinion: false,
  referrer: '',
  legalGuardian: false,
  legalGuardianDescription: '',
  voIsPresent: false,
  informationalConversation: false,
  informationalConversationDate: '',
  consultation: false,
  consultationDate: '',
  needsAssessmentInterview: false,
  needsAssessmentInterviewDate: '',
  documentsSentOn: '',
  note: '',

  children: null,
  street: '',
  mobilePhoneNumber: '',
  aaNumber: '',
  zip: '',
  fileNumber61p: '',
  fileNumberLandscapeAssociation: '',
  city: '',
  fileNumber61l: '',
  insuranceNumber: '',
  locationId: null,
  cardIK: '',
  nationality: '',
  birthDate: '',
  gender: '',
  maritalStatus: '',
  avgsStartDate: '',
  avgsEndDate: '',
  coPaymentExemption: '0',
  coPaymentExemptionStartDate: '',
  coPaymentExemptionEndDate: '',
});

const formRules = ref({
  firstName: requiredRule(t),
  lastName: requiredRule(t),
  status: requiredRule(t),
  contactPersonId: requiredRule(t),
  interestedIn: requiredRule(t),
  phone: requiredRule(t),
  email: isValidEmail(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

const submitForm = async () => {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coPaymentExemption = +formData.value.coPaymentExemption;

    if (unemployedId) {
      await unemployedService.putPotentialUnemployed(formData.value, route.params.id);
    } else {
      await unemployedService.postPotentialUnemployed(formData.value);
    }

    isSubmitting.value = false;
    await router.push({name: 'unemployedPotentialList'});
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
};

async function getUnemployedData() {
  try {
    const {data} = await unemployedService.getUnemployed(route.params.id);

    const contactPersonId = data.data?.contactPerson?.id;
    const locationId = data.data?.location?.id;
    const street = data.data?.address;
    const remindIn = String(data.data?.remindIn);
    const coPaymentExemption = String(data.data?.coPaymentExemption);
    const avgsStartDate = data.data?.startDate;
    const avgsEndDate = data.data?.endDate;

    formData.value = {
      ...data.data,
      contactPersonId: contactPersonId,
      locationId: locationId,
      remindIn: remindIn,
      street: street,
      coPaymentExemption: coPaymentExemption,
      avgsStartDate: avgsStartDate,
      avgsEndDate: avgsEndDate,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

const setAction = (actionType) => {
  formData.value.buttonType = actionType;
};

function finalSave() {
  showFinalSaveModal.value = true;
  formData.value.buttonType = 'finalSave';
}

watch(
    () => formData.value.specialistMedialOpinion,
    (newValue) => {
      if (newValue) {
        formRules.value = {...formRules.value, referrer: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, referrer: ''};
        formData.value.referrer = '';
      }
    },
);
watch(
    () => formData.value.legalGuardian,
    (newValue) => {
      if (newValue) {
        formRules.value = {...formRules.value, legalGuardianDescription: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, legalGuardianDescription: ''};

        formData.value.legalGuardianDescription = '';
      }
    },
);
watch(
    () => formData.value.informationalConversation,
    (newValue) => {
      if (newValue) {
        formRules.value = {...formRules.value, informationalConversationDate: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, informationalConversationDate: ''};

        formData.value.informationalConversationDate = '';
      }
    },
);
watch(
    () => formData.value.consultation,
    (newValue) => {
      if (newValue) {
        formRules.value = {...formRules.value, consultationDate: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, consultationDate: ''};

        formData.value.consultationDate = '';
      }
    },
);
watch(
    () => formData.value.needsAssessmentInterview,
    (newValue) => {
      if (newValue) {
        formRules.value = {...formRules.value, needsAssessmentInterviewDate: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, needsAssessmentInterviewDate: ''};

        formData.value.needsAssessmentInterviewDate = '';
      }
    },
);

function onUpdateEmailOrPhoneNumber() {
  if (formData.value.email) {
    formRules.value = {...formRules.value, phone: ''};
  } else {
    formRules.value = {...formRules.value, phone: requiredRule(t)};
  }
}

function onChangeInterestedIn(value, onMounted = false) {
  if (value === 'BeWo') {
    showAvgsAvailable.value = false
    formData.value.status = 'waiting_list';
    disableStatus.value = true
    moveLocationDropdown.value = true
    formRules.value = {...formRules.value, locationId: requiredRule(t)};
  } else {
    if(onMounted === false) {
      showAvgsAvailable.value = true
      formData.value.status = '';
      disableStatus.value = false
      moveLocationDropdown.value = false
      formData.value.note = '';
      formRules.value = {...formRules.value, locationId: ""};
    }
  }
}

const finalSaveButtonDisabled = computed(() => {
  return !formData.value.street ||
      !formData.value.city ||
      !formData.value.zip ||
      !formData.value.locationId ||
      !formData.value.birthDate;
});

const interestedInOptions = [
  {value: 'AMDL', label: 'AMDL'},
  {value: 'BeWo', label: 'BeWo'},
  {value: 'Sozio', label: 'Sozio'},
  {value: 'DRV', label: 'DRV'},
  {value: 'Sonstige', label: 'Sonstige'},
];

function onCoPaymentExceptionChange() {
  if (formData.value.coPaymentExemption === '1') {
    coPaymentExceptionDateDisable.value = false;
  } else {
    coPaymentExceptionDateDisable.value = true;
    formData.value.coPaymentExemptionStartDate = '';
    formData.value.coPaymentExemptionEndDate = '';
  }
}

onMounted(async () => {
  await Promise.all([
    getContactsForPotentialUnemployed(contactPersonsDropdown),
    getOfficeByUserRoleDropdown(officeDropdown),
  ]);

  if (unemployedId) {
    await getUnemployedData();
    onChangeInterestedIn(formData.value.interestedIn, true)
  }

  isLoaded.value = true;
});
</script>

<style scoped>
</style>